import { Flex, Heading, Button, Text, Icon } from '@chakra-ui/react';
import { useResourceRelationship } from 'datx-jsonapi-react';
import { FC } from 'react';

import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';

interface IVotingForm {
  setChangeVote: (changeVote: boolean) => void;
}

export const VotingSuccess: FC<IVotingForm> = ({ setChangeVote }) => {
  const { eventId } = useQueryParams<{ eventId }>({
    eventId: StringParam,
  });
  const { data: ec } = useResourceRelationship<EventConfiguration>(queryThinEventConfigurationRelationship(eventId));

  return (
    <Flex justifyContent="center" alignItems="center" w="full" h="full" mt={6}>
      <Flex flexDir="column" p={12} alignItems="center" w="451px" bg="white" borderRadius="md">
        <Heading textAlign="center" fontSize="lg" fontWeight="bold" lineHeight="2xl">
          {ec.lecturesVotingSuccessHeader}
        </Heading>
        <Text fontSize="md" color="gray.600" mt={4}>
          {ec.lecturesVotingSuccessDescription}
        </Text>
        <Flex mt={6} justifyContent="center" alignItems="center" w="72px" h="72px" borderRadius="50%" bg="teal.500">
          <Icon as={CheckMarkIcon} fontSize="52px" color="white" />
        </Flex>
        <Button mt={10} color="black" onClick={() => setChangeVote(true)} variant="link">
          {ec.lecturesVotingSuccessActionText}
        </Button>
      </Flex>
    </Flex>
  );
};
